import React from 'react';
import SamplePappers from './Components/SamplePappers';
import { BrowserRouter,Routes,Route } from 'react-router-dom';
import Notes from './Components/Notes';
import Mainmenu from './Components/Mainmenu';
import Topheader from './Components/Topheader';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Coursespage from './Components/Coursespage';
import Footer from './Components/Footer';

import Mainpage from './Components/Mainpage';
import Computerscience from './Components/class 10/Computerscience';
import Computer9 from './Components/class 9/Computer9';
import Computer11 from './Components/class 11/Computer11';
import Computer12 from './Components/class 12/Computer12';

function App() {
 

  return (
    <>
      <BrowserRouter>
        <Topheader />
        <Mainmenu />
        <Routes>
          <Route path='/' element={<Mainpage/>}></Route>
          <Route path='/online-neb-samplepappers' element={<SamplePappers/>}></Route>
          <Route path='/online-courses' element={<Coursespage/>}></Route>
          <Route path='/e-notes' element={<Notes/>}></Route>
          <Route path='/enotes-class-10/enotes-class-10-computer-science' element={<Computerscience/>}></Route>
          <Route path='/enotes-class-9/enotes-class-9-computer-science' element={<Computer9/>}></Route>
          <Route path='/enotes-class-11/enotes-class-11-computer-science' element={<Computer11/>}></Route>
          <Route path='/enotes-class-12/enotes-class-12-computer-science' element={<Computer12/>}></Route>
        </Routes>
       
       
       
          
      </BrowserRouter>
    </>
  );
}

export default App;
